export default __webpack_public_path__ + "static/media/ford-logo.37dc3cf2.png";